import React, { useCallback, useContext, useEffect } from 'react';
import { UnityMessageOutgoingEvent } from 'app/common/eventbus/Events';
import { NMUI4DContext } from 'app/common/context/NMUI4DContext';

import { VuplexInstance } from './types/Vuplex';

type TProps = {
    vuplexInstance: VuplexInstance;
};

export const VuplexSendMessageRequestForwarder = (props: React.PropsWithChildren<TProps>) => {
    const onForwardRequest = useCallback(
        (request: string) => {
            if (!props.vuplexInstance) {
                return; // Not running inside a Vuplex webview.
            }

            console.log('Sending request to Unity application API (Vuplex)', request);

            props.vuplexInstance?.postMessage(request);
        },
        [props.vuplexInstance],
    );

    const context = useContext(NMUI4DContext);

    useEffect(() => {
        if (!props.vuplexInstance) {
            return;
        }

        const eventCallback = (event: UnityMessageOutgoingEvent) => {
            onForwardRequest(event.request);
        };

        context.eventBus.register(UnityMessageOutgoingEvent.NAME, eventCallback);

        return () => {
            context.eventBus.unregister(UnityMessageOutgoingEvent.NAME, eventCallback);
        };
    }, [props.vuplexInstance]);

    return <>{props.children}</>;
};
